import { type CallAnalysisResponse } from "../api";
import { Utility } from "./utility";

export interface CallAnalysis extends CallAnalysisResponse {}

export class CallAnalysis extends Utility<CallAnalysis> {
  constructor(init?: Partial<CallAnalysisResponse>) {
    super();
    Object.assign(this, init);
  }
}
